import React from 'react';
import { Route, Link } from 'react-router-dom';
import { Breadcrumb, BreadcrumbItem } from 'reactstrap';
import routes from '../../constants/routes';

const findRouteName = url => {
  if (url === '/') return routes[url];

  // const urlLength=url.split('/').length;
  // const getRoute=Object.keys(routes)
  // .filter(key=>key.split('/').length==urlLength)
  // .filter(route => {
  //   return url.match((`${route.replace(/\\/g,'\/').replace(/\$/g,'\\')}$`));
  // });
  const getRoute=getRelatedRoutes(url);
  return getRoute.length?routes[getRoute[0]]:'No Name'
};

const getRelatedRoutes=(url)=>Object.keys(routes).filter(route=>url.match(`${route.replace(/\\/g,'\/').replace(/\$d/g,'\\d+').replace(/\$s/g, '\\S+')}$`))

const getPaths = (pathname) => {
  const paths = ['/'];

  if (pathname === '/') return paths;
  pathname.split('/').reduce((prev, curr, index) => {
    const currPath = `${prev}/${curr}`;
    paths.push(currPath);
    return currPath;
  });
  const resolvePaths=paths.filter(path=>getRelatedRoutes(path).length>0);
  return resolvePaths;
};

const BreadcrumbsItem = ({ match, ...rest }) => {
  const routeName = findRouteName(match.url);
  if (routeName) {
    return (
      match.isExact ?
      (
        <BreadcrumbItem active>{routeName}</BreadcrumbItem>
      ) :
      (
        <BreadcrumbItem>
          <Link to={match.url || ''}>
            {routeName}
          </Link>
        </BreadcrumbItem>
      )
    );
  }
  return null;
};

const Breadcrumbs = ({ location : { pathname }, match, ...rest }) => {
  const paths = getPaths(pathname);
  const i = 0;
  const items = paths.map((path, i) => <Route key={i++} path={path} component={BreadcrumbsItem} />);
  return (
    <Breadcrumb>
      {items}
    </Breadcrumb>
  );
};

export default props => (
  <div>
    <Route path="/:path" component={Breadcrumbs} {...props} />
  </div>
);
